import styled from 'styled-components';

export const StyledWarning = styled.div`
    .warning-message{
        color:${props => props.theme.colors.red}
    }
`;
